import { configureStore } from "@reduxjs/toolkit";

import app from "./appSlice";
import auth from "./authSlice";
import filters from "./filtersSlice";
import locationData from "./locationDataSlice";
import map from "./mapSlice";
import menu from "./menuSlice";
import modal from "./modalSlice";
import operation from "./operationSlice";
import points from "./pointsSlice";
import services from "./servicesSlice";
import stations from "./stationsSlice";
import surveys from "./surveysSlice";
import tooltip from "./tooltipSlice";
import zones from "./zonesSlice";
import layers from "./layerControlSlice";
import singleLocation from "./singleLocationSlice";
import camera from "./cameraSlice";
import inventory from "./inventorySlice";
import side from "./sideSlice";
import fleet from "./fleetSlice";
import star from "./starSlice";
import travel from "./travelSlice";
import traffic from "./trafficSlice";
import trafficFleet from "./trafficFleetSlice";
import event from "./eventSlice";
import waybill from "./waybillSlice";
import passage from "./passageSlice";
import marginPark from "./marginParkSlice";
import report from "./reportSlice";
import contact from "./contactSlice";
import page from "./pageSlice";
import trafficStations from "./trafficStationSlice";
import trafficZones from "./trafficZoneSlices";
import supportSide from "./supportSideSlice";
import supportInventory from "./supportInventorySlice";
import trafficPath from "./trafficPathSlice";
import streets from "./streetsSlice";

export const store = configureStore({
  reducer: {
    auth,
    operation,
    stations,
    points,
    zones,
    modal,
    locationData,
    menu,
    map,
    tooltip,
    surveys,
    services,
    filters,
    app,
    layers,
    singleLocation,
    camera,
    inventory,
    side,
    fleet,
    star,
    travel,
    traffic,
    trafficFleet,
    event,
    waybill,
    passage,
    marginPark,
    report,
    contact,
    page,
    trafficStations,
    trafficZones,
    supportSide,
    supportInventory,
    trafficPath,
    streets,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
